/**
 Created by qing on 2020/5/25
 Des: 我的流程组件图表
 */
import BaseChart from "../BaseChart"
import {CHART_CATEGORY__FLOW, CHART_TYPE__FLOW_CHART} from "../types"
import TodoChart from "./TodoChart";

class FlowChart extends BaseChart {
  constructor() {
    super()

    this.w = 15
    this.h = 8

    this.minH = 5

    this.showPropertiesHolder = {
      showTitle: 1
    }

    this.chartPropertiesHolder = {
      showDescription: 1,
      components: [
        {
          name: "我的待办",  //组件名称，:我的待办,urge:催办我的,create:我发起的,temp:我的草稿
          id: 'todo',
          show: 1, //是否展示
          num: 0
        },
        {
          name: "催办我的",  //组件名称，
          id: 'urge',
          show: 1, //是否展示
          num: 0
        },
        {
          name: "我发起的",  //组件名称，
          id: 'create',
          show: 1, //是否展示
          num: 0
        },
        {
          name: "我的草稿",  //组件名称，
          id: 'temp',
          show: 1, //是否展示
          num: 0
        },

      ]
    }
  }

  get title() {
    return this.chartName || FlowChart._title
  }

  set title(content) {
    this.chartName = content
  }

}

FlowChart._title = '我的流程'
FlowChart.type = CHART_TYPE__FLOW_CHART

FlowChart.prototype.chartCategory = CHART_CATEGORY__FLOW
FlowChart.prototype.chartType = FlowChart.type
FlowChart.prototype.getValue = function () {
}
export default FlowChart
